import { Injectable } from '@angular/core';
/** Default dropdown configuration */
var BsDropdownConfig = (function () {
    function BsDropdownConfig() {
        /** default dropdown auto closing behavior */
        this.autoClose = true;
    }
    BsDropdownConfig.decorators = [
        { type: Injectable },
    ];
    /** @nocollapse */
    BsDropdownConfig.ctorParameters = function () { return []; };
    return BsDropdownConfig;
}());
export { BsDropdownConfig };
//# sourceMappingURL=bs-dropdown.config.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-bootstrap/dropdown/bs-dropdown.config.js
// module id = 180
// module chunks = 42